//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
export default {
  name: 'AddSel',
  components: {
    draggable: draggable
  },
  props: {
    value: {
      default: function _default() {
        return [];
      },
      type: Array
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      activeData: this.value
    };
  },
  watch: {
    value: function value(n) {
      this.activeData = n;
    }
  },
  methods: {
    add1: function add1() {
      this.$emit('input', this.activeData);
    },
    addSelectItem: function addSelectItem() {
      this.activeData.push({
        label: '',
        value: ''
      });
      this.$emit('input', this.activeData);
    },
    setOptionValue: function setOptionValue(item, val) {
      item.label = val;
      item.value = val;
      this.$emit('input', this.activeData);
    }
  }
};